import { auth } from "../firebase/config";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
} from "firebase/auth";

// ── Admin Login ───────────────────────────────────────────────
export async function adminLogin(email, password) {
  try {
    const cred = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: cred.user };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Admin Logout ──────────────────────────────────────────────
export async function adminLogout() {
  try {
    await signOut(auth);
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Send Password Reset Email ─────────────────────────────────
export async function resetPassword(email) {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Listen for Login State Changes ───────────────────────────
// Keeps admin logged in even after page refresh
export function onAuthChange(callback) {
  return onAuthStateChanged(auth, callback);
}